import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Metatag from "../../hooks/Metatag";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import fellow2025 from '../../utils/data/gesh-fellow-2024-2025.json';
import fellow2026 from '../../utils/data/gesh-fellow-2025-2026.json';
import livingLabProjects from '../../utils/data/living-lab-projects.json';
import {formatPageName} from "../../utils/functions";

    
const getProjectName = (projectName) => {
  const normalizedName = formatPageName(projectName);
  if (!normalizedName) return null;

  const exactMatch = livingLabProjects.find(
    (project) => formatPageName(project.project) === normalizedName,
  );
  
  return exactMatch?.project;

};

export default function GESHfellows() {
  const [expanded, setExpanded] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2026");

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10
        ? $(".fixed-top").removeClass("bg-header-home")
        : $(".fixed-top").removeClass("bg-header-home");
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <>
      <Header></Header>

      <Metatag
        title="GESH IITB Living Lab Program"
        description="GESH IITB Living Lab Program"
        keywords="GESH IITB Living Lab Program"
      />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0">
        <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Living Lab Fellows
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Container */}
      <Container className="mt-5">
        <Row>
          <Col>
            <Navbar
              expanded={expanded}
              collapseonselect
              expand="md"
              className="d-block p-0 m-0 container"
            >
              <Navbar.Toggle
                onClick={() => setExpanded(expanded ? false : "expanded")}
                className="offcanvas-toggle shadow-none w-100 animated fadeInUp"
                aria-controls={"offcanvas-menu"}
              >
                <Link className="btn border rounded-4 mb-4 px-4 py-2 w-100 text-start d-flex justify-content-between rounded-0 align-items-center d-md-none">
                  {selectedYear === "2026" ? "2025-2026" : "2024-2025"}{" "}
                  <HiOutlineMenuAlt2 />
                </Link>
              </Navbar.Toggle>
              <Navbar.Offcanvas
                id={"offcanvasTop"}
                aria-labelledby={"offcanvasTop"}
                placement="start"
                responsive="md"
                className="p-md-0 p-2 d-block"
              >
                <Offcanvas.Header
                  closeButton
                  onClick={() => setExpanded(false)}
                >
                  <Offcanvas.Title></Offcanvas.Title>
                </Offcanvas.Header>
                <ul className="people-nav d-md-flex ms-md-3 w-100">
                  <li>
                    <Link
                      className={`nav-link ${
                        selectedYear === "2026" ? "active" : ""
                      }`}
                      onClick={() => {
                        setExpanded(false);
                        setSelectedYear("2026");
                      }}
                    >
                     Cohort 2 (2025-2026)
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`nav-link ${
                        selectedYear === "2025" ? "active" : ""
                      }`}
                      onClick={() => {
                        setExpanded(false);
                        setSelectedYear("2025");
                      }}
                    >
                      Cohort 1 (2024-2025)
                    </Link>
                  </li>
                </ul>
              </Navbar.Offcanvas>
            </Navbar>
          </Col>
        </Row>
      </Container>
      <Container className="mb-5">
        <Row className="g-0">
          {selectedYear === "2026" && (
            <div className="border rounded-4 p-xl-5 p-3 h-100">
              <Row className="row-cols-1 g-xl-5 g-4">
                <Col id="IndustryTrainingPrograms">
                  <Row className="g-0 mb-5">
                    <Col
                      md={8}
                      lg={8}
                      className="ps-lg-5 pe-md-4 order-lg-2 d-flex flex-column justify-content-center"
                    >
                      <h4 className="mb-3 wow fadeInUp">
                        GESH IITB Fellows 2025-2026
                      </h4>
                      <p className="wow fadeInUp">
                        Following the success of Cohort 1, we are excited to
                        welcome Cohort 2 of the GESH IITB Living Lab Fellowship
                        Program. This year’s eight-month fellowship features
                        projects co-designed with thematic committees on water,
                        waste, and sustainability awareness. In addition to
                        project work, fellows will engage in masterclasses,
                        community outreach, experiential visits and tours
                        related to sustainability for a holistic learning
                        experience.
                      </p>
                      <p className="wow fadeInUp">
                        Cohort 2 brings together 11 students from seven
                        departments across undergraduate, postgraduate, and
                        doctoral levels working on six projects that address key
                        sustainability challenges on the IIT Bombay campus.
                      </p>
                    </Col>
                    <Col md={4} lg={4} className="order-lg-1">
                      <img
                        src={
                          global.variables.strDomainUrl +
                          "images/gesh-fellows-2026.jpg"
                        }
                        alt=""
                        title=""
                        className="img-fluid rounded-3 w-100 wow fadeInUp"
                      />
                    </Col>
                  </Row>

                  <Row className="g-0 row-cols-1 row-cols-md-3 row-cols-xl-4 g-4">
                    {
                      fellow2026.map((fellow,index)=>(
                        <Col key={index}>
                          <div className="h-100 border rounded-3 p-3">
                            <div className="text-center">
                              <img
                                src={global.variables.strDomainUrl + "images/geshfellow/" + fellow.image}
                                alt={fellow.name}
                                title={fellow.name}
                                className="img-fluid rounded-circle mb-3"
                              />
                              <h5 className="text-dark mb-1">{fellow.name}</h5>
                              <p className="m-0 small">
                                <b>Program:</b> {fellow.program}
                              </p>
                              <p className="m-0 small">
                                <b>Project: </b>
                                {(() => {
                                  const project = getProjectName(fellow.project);
                                  return project ? (
                                    <Link
                                      to={`/campus-sustainability/projects/${formatPageName(project)}`}
                                      
                                    >
                                      {fellow.project}
                                    </Link>
                                  ) : (
                                    fellow.project
                                  );
                                })()}
                              </p>
                            </div>
                          </div>
                        </Col>
                      ))
                    }
                    
                  </Row>
                </Col>
              </Row>
            </div>
          )}
          {selectedYear === "2025" && (
            <div className="border rounded-4 p-xl-5 p-3 h-100">
              <Row className="row-cols-1 g-xl-5 g-4">
                <Col id="IndustryTrainingPrograms">
                  <Row className="g-0 mb-5">
                    <Col
                      md={8}
                      lg={8}
                      className="ps-lg-5 pe-md-4 order-lg-2 d-flex flex-column justify-content-center"
                    >
                      <h4 className="mb-3 wow fadeInUp">
                        GESH IITB Fellows 2024-2025
                      </h4>
                      <p className="wow fadeInUp">
                        The inaugural cohort of GESH IITB Living Lab Fellowship
                        features 15 passionate students from diverse academic
                        disciplines, spanning Undergraduate, Master’s, and Ph.D.
                        programs. These GESH IITB Fellows are collaborating on
                        transformative projects that tackle key sustainability
                        challenges on campus.
                      </p>
                    </Col>
                    <Col md={4} lg={4} className="order-lg-1">
                      <img
                        src={
                          global.variables.strDomainUrl +
                          "images/gesh-fellows.jpg"
                        }
                        alt=""
                        title=""
                        className="img-fluid rounded-3 w-100 wow fadeInUp"
                      />
                    </Col>
                  </Row>

                  <Row className="g-0 row-cols-1 row-cols-md-3 row-cols-xl-4 g-4">
                    {/* Achintya Bhobe */}
                    {
                      fellow2025.map((fellow,index)=>(
                        <Col key={index}>
                          <div className="h-100 border rounded-3 p-3">
                            <div className="text-center">
                              <img
                                src={global.variables.strDomainUrl + "images/geshfellow/" + fellow.image}
                                alt={fellow.name}
                                title={fellow.name}
                                className="img-fluid rounded-circle mb-3"
                              />
                              <h5 className="text-dark mb-1">{fellow.name}</h5>
                              <p className="m-0 small">
                                <b>Program:</b> {fellow.program}
                              </p>
                              <p className="m-0 small">
                                <b>Project: </b>
                                {(() => {
                                  const project = getProjectName(fellow.project);
                                  console.log(project);
                                  
                                  return project ? (
                                    <Link
                                      to={`/campus-sustainability/projects/${formatPageName(project)}`}
                                      
                                    >
                                      {fellow.project}
                                    </Link>
                                  ) : (
                                    fellow.project
                                  );
                                })()}
                              </p>
                            </div>
                          </div>
                        </Col>
                      ))
                    }
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </Row>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Campus Sustainability</Breadcrumb.Item>
        <Breadcrumb.Item active>GESH IITB Living Lab Program</Breadcrumb.Item>
        <Breadcrumb.Item active>Living Lab Fellows</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}

